import { randWord, randNumber, randPastDate, randFullAddress, randCatchPhrase, randAirportCode, rand, randRecentDate } from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { MockCalculator } from './calculator.mock';

import { Container } from '../base';
import { IGenericType } from '@library/common/generictype';
import { Milestones, MilestonesConst } from '../shipment';

export class MockContainer extends Container {
   // constructor( itemized = false ) {
   constructor( itemized = true ) {
      super({
         type: randWord(),
      });

      this.number = randAirportCode()+"-"+randNumber({ min: 1000, max: 99999 }).toString()+"-"+randNumber({min: 1, max: 9 }).toString();
      if ( optional() ) { this.sealNumber = randWord(); }
      if ( itemized || optional() ) {
      // if ( itemized ) {
         this.items = Array.from({ length: randNumber({ max: 10 })}, _ => new MockCalculator() );
      }

      this.status = Array.from({ length: randNumber({ min: 3, max: 10 })}, _ => ( randStat() )); 

      this.milestones = Milestones( 'ocean' );
      const length = randNumber({ max: Object.keys( this.milestones ).length });
      Object.keys( this.milestones ).map(( key, index ) => {
         if ( index == 0 || (index < length && optional()) ) {
            this.milestones[key] = randRecentDate({ days: 10 });
         }
      });
   }
}

function randStat(): IGenericType {
   const randDate = Math.floor(new Date(randPastDate() as any).getTime() as any / 1000);
   const fullDate:Date = new Date(randDate as any * 1000) as any;

   const optionsDate: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      timeZone: 'UTC'
   };

   const optionsTime: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'UTC'
   };

   const formattedDate = new Intl.DateTimeFormat("en-US", optionsDate).format(fullDate);
   const formattedTime = new Intl.DateTimeFormat("en-US", optionsTime).format(fullDate);

   return {
      date : formattedDate,
      time : formattedTime,
      code: rand( MilestonesConst() ).code,
      status : rand( MilestonesConst() ).label,
      description : optional() ? randCatchPhrase() : "",
      location : optional() ? randFullAddress() : ""
   }
}
